import type { PlaneInput } from '../sim/sim.js';
/** Six shared action bits, matching biplanes_core::Input. Eject is an input edge. */
export function inputMask(input: PlaneInput): number {
  return (
    Number(input.climb) |
    (Number(input.dive) << 1) |
    (Number(input.left) << 2) |
    (Number(input.right) << 3) |
    (Number(input.fire) << 4) |
    (Number(input.eject ?? false) << 5)
  );
}
